export default __webpack_public_path__ + "static/media/aircon.67924ba6.svg";